import { render, staticRenderFns } from "./SupplierOnboardingBankAccount.vue?vue&type=template&id=75824acc&"
import script from "./SupplierOnboardingBankAccount.vue?vue&type=script&lang=js&"
export * from "./SupplierOnboardingBankAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports